import React from "react";
import WebKalkulator from "../../WebKalkulator/View";

const AddOffer = ({ state, actions }) => {
  return <WebKalkulator isAddOffer={true} state={state} actions={actions} />;
};

export default AddOffer;
